export const getOfferQueryKey = (id?: string) => {
  return ["offerGet", id ?? ""];
};
